import { Alert } from ".."
import Ajax from "../Ajax"

export const fileFormats = {
    "jpg": "image/jpeg",
    "JPG": "image/jpeg",
    "jpeg": "image/jpeg",
    "JPEG": "image/jpeg",
    "png": "image/png",
    "PNG": "image/png",
    "bmp": "image/bmp",
    "BMP": "image/bmp",
    "pdf": "application/pdf",
    "PDF": "application/pdf"
}

export function downloadBase64File(fileName, base64String, mimeType) {
    const downloadLink = document.createElement('a')
    if (mimeType in fileFormats) {
        mimeType = fileFormats[mimeType]
    }
    downloadLink.href = `data:${mimeType};base64,${base64String}`
    downloadLink.download = fileName
    downloadLink.click()
}

export async function downloadAttachment (uid) {
    await Ajax.Questionnaire.GetUpload(uid).then(response => {
        downloadBase64File(response.data.displayName, response.data.data, response.data.fileFormat)
    }).catch(() => {
        Alert({message: "Unable to download file"})
    })
}